<!--
  El avatar y el nombre estaban escritos dos veces, carácter a carácter: lo único que
  cambia entre las dos ramas es la etiqueta que los envuelve, <a> con href cuando el
  usuario es enlazable y <div> cuando no.
-->
@if (link()) {
  <a
    class="user invisible theme-bg"
    [class.modal_is_open]="userStatiticsIsOpen()"
    [class.theme-chollo-user-container]="statitics()"
    [href]="'/user/' + (user() ? $safeNavigationMigration(user()?.id) : '') + '/'"
    (click)="isMobileBrowser && statitics() ? openUserStats($event) : false"
    (mouseenter)="!isMobileBrowser && statitics() ? mouseenter($event) : false"
    (mouseleave)="mouseleave()"
    appGoToUrl
    >
    <ng-container *ngTemplateOutlet="avatarYNombre"></ng-container>
  </a>
} @else {
  <div
    class="user invisible theme-bg"
    [class.modal_is_open]="userStatiticsIsOpen()"
    [class.theme-chollo-user-container]="statitics()"
    (click)="isMobileBrowser && statitics() ? openUserStats($event) : false"
    (mouseenter)="!isMobileBrowser && statitics() ? mouseenter($event) : false"
    (mouseleave)="mouseleave()"
    >
    <ng-container *ngTemplateOutlet="avatarYNombre"></ng-container>
  </div>
}

<ng-template #avatarYNombre>
  <div class="user_img theme-bg theme-border-color theme-chollo-user" [class.background_red]="!user()?.image_url">
    <div>
      @if (user()?.image_url) {
        <img
          onError="this.src='/assets/images/logo_quad.webp'; this.srcset='/assets/images/logo_quad.webp'"
          alt="Foto de perfil"
          [title]="$safeNavigationMigration(user()?.username)"
          [src]="$safeNavigationMigration(user()?.image_url)"
          width="32" height="32"
          appLazyload
          [ssrWidth]="64"
          >
      } @else {
        <img
          [src]="'/assets/images/logo_quad.webp'"
          [srcset]="'/assets/images/logo_quad.webp'"
          alt="Foto de perfil"
          [title]="$safeNavigationMigration(user()?.username)"
          width="32" height="32"
          loading="lazy" decoding="async"
          >
      }
    </div>
    @if (user()?.bluetick) {
      <img alt="" class="tick_icon" src="/assets/icons/trust.svg" width="16" height="15" loading="lazy" decoding="async"/>
    }
  </div>
  <div class="user_name theme-text theme-title"> {{ user()?.username }}</div>
</ng-template>
